<template>
    <div>
        <div class="head">
            <h2>校园风采</h2>
            <span class="more">更多>></span>
        </div>
        <div class="content">
            <div class="left">
                <video :src="homeVideo.videoUrl" controls></video>
            </div>
            <div class="right">
                <div v-for="item in imgList" :key="item.csId">
                    <img :src="item.img">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {apiService} from "@/api/ApiService.js"
    export default {
        name: 'CampusStyle',
        mounted () {
            // 查询视频
            apiService.findSchoolVideo({isHomeShow: 1, pageNum: 1, pageSize: 1}).then(res => {
                this.homeVideo = res.data.list[0]
            })
            // 查询校园风采图
            apiService.findCampusStyleImg({pageNum: 1, pageSize: 4}).then(res => {
                this.imgList = res.data.list
            })
        },
        data() {
            return {
                homeVideo: {},
                imgList: []
            }
        }
    }
</script>
<style scoped>
    .head {
        height: 0.8rem;
        background-image: linear-gradient(to right, rgba(15, 49, 133, 0.8), rgba(171, 46, 52, 0.8)), url('../assets/imgs/bg1.jpeg');
        background-size: cover;
        background-position: bottom center;
        position: relative;
        user-select: none;
    }
    .head>h2 {
        font-size: 0.15rem;
        text-align: center;
        color: #fff;
        line-height: 100px;
    }
    .head>.more {
        position: absolute;
        right: 0.05rem;
        top: 0.05rem;
        font-size: 0.06rem;
        cursor: pointer;
        color: #fff;
    }
    .content {
        height: 2rem;
        display: flex;
        margin-top: 5px;
    }
    .content>div {
        flex: 1;
    }
    .content>.left {
        margin-right: 5px;
    }
    .content>.left>video {
        width: 100%;
        height: 100%;
    }
    .right {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 0.95rem 0.95rem;
        grid-row-gap: 0.1rem;
    }
    .right>div {
        margin-left: 5px;
        text-align: center;
        overflow: hidden;
    }
    .right img {
        width: auto;
        min-width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/CampusStyle.vue